import * as _ from 'lodash-es';

export interface FileType {
    ext: string;
    mimeType: string;
    category: FileCategory;
    faClass: string;
}

export enum FileCategory {
    AUDIO,
    VIDEO,
    PHOTO,
    IMAGE,
    MISC,
    INTERNAL,
    TEMPLATE,
    ASSESSMENT,
    CORRESPONDENCE
}

export class FileTypes {

    public static readonly ALL: FileType[] = [
        { ext: null, mimeType: null, category: null, faClass: 'fa-file' },
        { ext: 'wav', mimeType: 'audio/wav', category: FileCategory.AUDIO, faClass: 'fa-file-audio' },
        { ext: 'amr', mimeType: 'audio/amr', category: FileCategory.AUDIO , faClass: 'fa-file-audio'},
        { ext: 'mp3', mimeType: 'audio/mp3', category: FileCategory.AUDIO,  faClass: 'fa-file-audio' },
        { ext: 'mov', mimeType: 'video/mov', category: FileCategory.VIDEO,  faClass: 'fa-file-video' },
        { ext: '3gp', mimeType: 'video/3gpp', category: FileCategory.VIDEO, faClass: 'fa-file-video' },
        { ext: 'mp4', mimeType: 'video/mp4', category: FileCategory.VIDEO,  faClass: 'fa-file-video' },
        { ext: 'jpg', mimeType: 'image/jpeg', category: FileCategory.PHOTO, faClass: 'fa-file-image' },
        { ext: 'jpeg', mimeType: 'image/jpeg', category: FileCategory.PHOTO, faClass: 'fa-file-image' },
        { ext: 'png', mimeType: 'image/png', category: FileCategory.PHOTO, faClass: 'fa-file-image' },
        { ext: 'gif', mimeType: 'image/gif', category: FileCategory.PHOTO, faClass: 'fa-file-image' },
        { ext: 'bmp', mimeType: 'image/bmp', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'tiff', mimeType: 'image/tiff', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'pjp', mimeType: 'image/pjpeg', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'pjpeg', mimeType: 'image/pjpeg', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'jfif', mimeType: 'image/pjpeg', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'ico', mimeType: 'image/x-icon', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'webp', mimeType: 'image/webp', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'xbm', mimeType: 'image/x-xbitmap', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'dib', mimeType: 'image/bmp', category: FileCategory.IMAGE, faClass: 'fa-file-image' },
        { ext: 'doc', mimeType: 'application/msword', category: FileCategory.MISC, faClass: 'fa-file-word' },
        { ext: 'docx', mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', category: FileCategory.MISC, faClass: 'fa-file-word' },
        { ext: 'xls', mimeType: 'application/vnd.ms-excel', category: FileCategory.MISC, faClass: 'fa-file-excel' },
        { ext: 'xlsx', mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', category: FileCategory.MISC, faClass: 'fa-file-excel' },
        { ext: 'ppt', mimeType: 'application/vnd.ms-powerpoint', category: FileCategory.MISC, faClass: 'fa-file-powerpoint' },
        { ext: 'pptx', mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', category: FileCategory.MISC, faClass: 'fa-file-powerpoint' },
        { ext: 'pdf', mimeType: 'application/pdf', category: FileCategory.MISC, faClass: 'fa-file-pdf' },
        { ext: 'txt', mimeType: 'text/plain', category: FileCategory.MISC, faClass: 'fa-file-alt' },
        { ext: 'xsl', mimeType: 'text/xml', category: FileCategory.TEMPLATE, faClass: 'fa-file-code' },
        { ext: 'xslt', mimeType: 'application/xslt+xml', category: FileCategory.TEMPLATE, faClass: 'fa-file-code' }
    ];

    public static getByKey(key: string): FileType {
        key = typeof key === 'string' ? key.toLowerCase() : key;
        let found = _.find(FileTypes.ALL, (type: FileType) => type.ext === key);
        found = found ? found : _.find(FileTypes.ALL, (type: FileType) => type.ext === null);
        return found;
    }

    public static getByCategory(category: FileCategory): FileType[] {
        return _.filter(FileTypes.ALL, (type: FileType) => type.category === category);
    }

    public static get WAV() {
        return FileTypes.getByKey('wav');
    }

    public static get AMR() {
        return FileTypes.getByKey('amr');
    }

    public static get MP3() {
        return FileTypes.getByKey('mp3');
    }

    public static get MOV() {
        return FileTypes.getByKey('mov');
    }

    public static get '3GP'() {
        return FileTypes.getByKey('3gp');
    }

    public static get MP4() {
        return FileTypes.getByKey('mp4');
    }

    public static get JPG() {
        return FileTypes.getByKey('jpg');
    }

    public static get JPEG() {
        return FileTypes.getByKey('jpeg');
    }

    public static get PNG() {
        return FileTypes.getByKey('png');
    }

    public static get GIF() {
        return FileTypes.getByKey('gif');
    }

    public static get BMP() {
        return FileTypes.getByKey('bmp');
    }

    public static get TIFF() {
        return FileTypes.getByKey('tiff');
    }

    public static get PJP() {
        return FileTypes.getByKey('pjp');
    }

    public static get PJPEG() {
        return FileTypes.getByKey('pjpeg');
    }

    public static get JFIF() {
        return FileTypes.getByKey('jfif');
    }

    public static get ICO() {
        return FileTypes.getByKey('ico');
    }

    public static get WEBP() {
        return FileTypes.getByKey('webp');
    }

    public static get XBM() {
        return FileTypes.getByKey('xbm');
    }

    public static get DIB() {
        return FileTypes.getByKey('dib');
    }

    public static get DOC() {
        return FileTypes.getByKey('doc');
    }
    
    public static get DOCX() {
        return FileTypes.getByKey('docx');
    }

    public static get XLS() {
        return FileTypes.getByKey('xls');
    }

    public static get XLSX() {
        return FileTypes.getByKey('xlsx');
    }

    public static get PPT() {
        return FileTypes.getByKey('ppt');
    }

    public static get PPTX() {
        return FileTypes.getByKey('pptx');
    }

    public static get PDF() {
        return FileTypes.getByKey('pdf');
    }

    public static get TXT() {
        return FileTypes.getByKey('txt');
    }

    public static get XSL() {
        return FileTypes.getByKey('xsl');
    }

    public static get XSLT() {
        return FileTypes.getByKey('xslt');
    }

    public static get TYPES_AUDIO() {
        return FileTypes.getByCategory(FileCategory.AUDIO);
    }

    public static get TYPES_PHOTO() {
        return FileTypes.getByCategory(FileCategory.PHOTO);
    }

    public static get TYPES_IMAGE() {
        return FileTypes.getByCategory(FileCategory.IMAGE);
    }

    public static get TYPES_VIDEO() {
        return FileTypes.getByCategory(FileCategory.VIDEO);
    }

    public static get TYPES_MISC() {
        return FileTypes.getByCategory(FileCategory.MISC);
    }

    public static get TYPES_TEMPLATE() {
        return FileTypes.getByCategory(FileCategory.TEMPLATE);
    }

    public static get EDITABLE_IMAGES() {
        return FileTypes.TYPES_PHOTO.concat([FileTypes.BMP]);
    }

    public static isEditableFileType(type: FileType) {
        return FileTypes.EDITABLE_IMAGES.indexOf(type) > -1;
    }
}
